module.exports = __webpack_public_path__ + "static/img/20191.429749f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/20191.jpg
// module id = Gy8d
// module chunks = 1